import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './types';
import caseReducers from './caseReducers';

export const twilioSlice = createSlice({
  name: 'twilio',
  initialState,
  reducers: caseReducers,
});

export const {
  setConversationsClient,
  setConnectionState,
  addParticipant,
  updateParticipant,
  setChatInterface,
  addMetadata,
  removeMetadata,
  updateMetadata,
  setSelectedChat,
  addMessages,
  setChatAlert,
  editGroupParticipants,
  setImageViewerInitial,
  setAllConversationsLoaded,
  updateReachabilityStatus,
} = twilioSlice.actions;

export default twilioSlice.reducer;
